import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { resetPassword, clearResetPassword } from 'redux/users/actions';

import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Form } from 'semantic-ui-react';

import InputTextField from 'components/redux-form-adapters/InputTextField';
// import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';


const ResetPasswordForm = props => {
  const {
    confirmationKey,
    handleSubmit,
    resetPassword,
    clearResetPassword,
    resetPasswordSuccess,
    resetPasswordError,
    valid,
  } = props;

  useEffect(() => {
    return () => {
      clearResetPassword();
    };
  }, []);

  const _handleSubmit = values => {
    resetPassword(
      confirmationKey,
      values.password1,
      values.password2,
    );
  };

  return (
    <div className="reset-password-form__component">
      <h1>Reset Password</h1>

      {!resetPasswordSuccess &&
        <Form
          onSubmit={handleSubmit(_handleSubmit)}
          error={!valid}
        >
          {/* Password 1 */}
          <Field
            label="New Password"
            component={InputTextField}
            name="password1"
            type="password"
            // placeholder="Enter new password"
            required
          />

          {/* Password 2 */}
          <Field
            label="Confirm Password"
            component={InputTextField}
            name="password2"
            type="password"
            // placeholder="Confirm password"
            required
          />

          <Button
            submit
            disabled={!valid}
          >
            reset password
          </Button>

        </Form>
      }

      {resetPasswordSuccess &&
        <CommonMessage success>
          <div>Password has been changed!</div>
          <Link to="/login">Login</Link>
        </CommonMessage>
      }

      {resetPasswordError &&
        <CommonMessage
          error
          errors={resetPasswordError}
        />
      }
    </div>
  );
};

ResetPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  clearResetPassword: PropTypes.func.isRequired,
  confirmationKey: PropTypes.string.isRequired,
  resetPasswordSuccess: PropTypes.object,
  resetPasswordError: PropTypes.object,
};

ResetPasswordForm.defaultProps = {
  resetPasswordSuccess: null,
  resetPasswordError: null,
};

const mapStateToProps = state => (
  {
    resetPasswordSuccess: state.usersReducer.resetPasswordSuccess,
    resetPasswordError: state.usersReducer.resetPasswordError,
  }
);

export default connect(
  mapStateToProps,
  {
    resetPassword,
    clearResetPassword,
  },
)(reduxForm({
  form: 'ResetPasswordForm',
  validate,
})(ResetPasswordForm));
